<!--
  outstand deletes uploaded media 60 days after upload, and a post can sit in
  a bin longer than that. We don't keep the original bytes, so the only fix is
  for the user to re-upload — this just makes the deadline visible before the
  post goes out with a missing image.
-->
<script>
  import Icon from '@iconify/svelte';

  let { expired = false, expiringSoon = false, expiresAt = null } = $props();

  let days = $derived(
    expiresAt ? Math.ceil((new Date(expiresAt) - new Date()) / 86400000) : null,
  );

  let label = $derived(
    expired
      ? 'Image expired — re-upload before this posts'
      : days === null
        ? 'Image may have expired'
        : `Image expires in ${days} ${days === 1 ? 'day' : 'days'}`,
  );
</script>

{#if expired || expiringSoon}
  <span
    class="text-xs flex items-center gap-1 {expired ? 'text-red-600' : 'text-amber-600'}"
    title={expiresAt ? `Expires ${new Date(expiresAt).toLocaleString()}` : undefined}
  >
    <Icon icon={expired ? 'mdi:image-off-outline' : 'mdi:clock-alert-outline'} />
    {label}
  </span>
{/if}
